import LegalLayout from "@/components/LegalLayout";

export default function TermsAndConditions() {
  return (
    <LegalLayout title="Terms & Conditions" updated="15 September 2026" testId="terms-page">
      <p>
        These Terms &amp; Conditions ("Terms") govern your use of PathfinderAiClub (the "Platform", "we",
        "us"), an AI-powered psychometric and career assessment service for school students. PathfinderAiClub
        is a product owned and operated by MOFOHP DYNAMICS PRIVATE LIMITED, a company incorporated under the
        laws of India ("Company", "we", "us", "our"). By creating an account or using the Platform, you agree
        to these Terms.
      </p>

      <h2>1. Who can use the Platform</h2>
      <p>
        The Platform is intended for students (typically Grades 8–12), their parents/guardians, and school
        staff (counselors, principals, admins) acting on behalf of a school. If you are under 18, you should
        use the Platform with the involvement and consent of a parent, guardian, or school representative.
      </p>

      <h2>2. Your account</h2>
      <ul>
        <li>You're responsible for providing accurate information (name, grade, board, contact details) and keeping it up to date.</li>
        <li>You're responsible for keeping your login credentials confidential and for activity that happens under your account.</li>
        <li>Schools, parents, and counselors who create or manage accounts on behalf of students are responsible for having the appropriate consent to do so.</li>
      </ul>

      <h2>3. The assessment and AI-generated content</h2>
      <p>
        The Platform generates career guidance — including personality, aptitude, and interest analysis, and
        career/stream recommendations — using AI based on your responses. This content is intended to be
        informational and educational, to help you explore options aligned with the National Education Policy
        (NEP) 2020. It is <strong>not</strong> professional career counseling, psychological, medical, or
        educational advice, and it does not guarantee any particular academic or career outcome. Always use
        your own judgment, and consult a qualified counselor or professional for decisions that matter to you.
      </p>

      <h2>4. Payments</h2>
      <p>
        Certain features (such as unlocking your full assessment report) require a one-time payment, shown
        and confirmed at checkout before you pay. Payments are processed securely by our payment partner,
        Cashfree; we do not store your card or bank details. All amounts are in Indian Rupees (INR) and
        inclusive of applicable platform fees and GST as itemised at checkout. See our{" "}
        <a href="/refund-policy">Refund &amp; Cancellation Policy</a> for how refunds and failed payments are
        handled.
      </p>

      <h2>5. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Misrepresent your identity, age, grade, or school affiliation;</li>
        <li>Attempt to access another user's account, data, or another school's data without authorisation;</li>
        <li>Copy, resell, or redistribute assessment content or reports for commercial purposes without our permission;</li>
        <li>Interfere with or attempt to disrupt the Platform's normal operation.</li>
      </ul>

      <h2>6. Intellectual property</h2>
      <p>
        The Platform, including its assessment questions, scoring methodology, design, and branding, is owned
        by MOFOHP DYNAMICS PRIVATE LIMITED (operating the PathfinderAiClub product) or its licensors. Your
        individual assessment report is yours to use personally (e.g. to save, print, or share with your
        school or family).
      </p>

      <h2>7. Disclaimer of warranties</h2>
      <p>
        The Platform is provided "as is". While we work to keep the assessment accurate and reliable, we
        don't guarantee that it will be uninterrupted, error-free, or that AI-generated recommendations will
        be complete or suited to every individual circumstance.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the extent permitted by law, PathfinderAiClub will not be liable for indirect, incidental, or
        consequential damages arising from your use of the Platform, including decisions made based on
        assessment results or AI-generated content. Our total liability for any claim relating to the
        Platform is limited to the amount you paid us in the preceding 12 months.
      </p>

      <h2>9. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time to reflect changes to the Platform or applicable law.
        We'll update the "Last updated" date above when we do. Continued use of the Platform after a change
        means you accept the updated Terms.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These Terms are governed by the laws of India, and any disputes will be subject to the exclusive
        jurisdiction of the courts of India.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about these Terms? Reach us at{" "}
        <a href="mailto:support@pathfinderaiclub.com">support@pathfinderaiclub.com</a> — see our{" "}
        <a href="/contact">Contact Us</a> page.
      </p>

      <h2>12. Ownership of the Platform</h2>
      <p>
        PathfinderAiClub is a product of, and is owned and operated by, MOFOHP DYNAMICS PRIVATE LIMITED, a
        company duly incorporated under the Companies Act, 2013 and having its registered office at:
      </p>
      <p>
        MOFOHP DYNAMICS PRIVATE LIMITED<br />
        Office No. 12114, 12th Floor, Gaur City Mall<br />
        C-01/BGH-01, Sector-04<br />
        Greater Noida, Uttar Pradesh 201301<br />
        India
      </p>
      <p>
        All references to "PathfinderAiClub", "the Platform", "we", "us", or "our" in these Terms refer to
        MOFOHP DYNAMICS PRIVATE LIMITED, unless the context otherwise requires. Any legal notice, correspondence,
        or claim relating to the Platform shall be addressed to MOFOHP DYNAMICS PRIVATE LIMITED at the
        registered office above.
      </p>
    </LegalLayout>
  );
}
